import React, { useEffect } from 'react';
import { MdImportantDevices, MdLoyalty } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import { Content, Footer, Header, Sidebar } from 'components/Layout';
import './Layout.css';

const MainLayout = ({ children, breakpoint }) => {
  const [isSidebarOpened, setIsSidebarOpened] = React.useState(true);

  useEffect(() => {
    const sidebar = document.querySelector('.cr-sidebar');
    if (sidebar !== null) {
      setIsSidebarOpened(sidebar.classList.contains('cr-sidebar--open'));
    }
  }, []);

  if (localStorage.getItem('LoggedIn') === 'Yes') {
    setInterval(() => {
      const sidebar = document.querySelector('.cr-sidebar');
      if (sidebar !== null) {
        setIsSidebarOpened(sidebar.classList.contains('cr-sidebar--open'));
      }
    }, 1000);
  }

  useEffect(() => {
    checkBreakpoint(breakpoint);
  }, [breakpoint]);

  const checkBreakpoint = breakpoint => {
    switch (breakpoint) {
      case 'xs':
      case 'sm':
      case 'md':
        return openSidebar('close');

      case 'lg':
      case 'xl':
      default:
        return openSidebar('open');
    }
  };

  const openSidebar = openOrClose => {
    const sidebar = document.querySelector('.cr-sidebar');
    if (openOrClose === 'open') {
      sidebar.classList.add('cr-sidebar--open');
    } else {
      sidebar.classList.remove('cr-sidebar--open');
    }
  };

  const handleContentClick = () => {
    if (
      isSidebarOpened &&
      (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md')
    ) {
      openSidebar('close');
    }
  };

  return (
    <main className="cr-app  bg-light">
      <Sidebar />
      <Content fluid onClick={handleContentClick} className="p-0">
        <Header />
        <div
          style={{ marginTop: '85px' }}
          className={`${
            isSidebarOpened ? 'main-layout-widthbase' : 'main-layout-100vw'
          } p-0`}
        >
          {children}
        </div>
        <Footer />
      </Content>

      <NotificationSystem
        dismissible={false}
        style={NOTIFICATION_SYSTEM_STYLE}
      />
    </main>
  );
};

export default MainLayout;
